/*Mahesh S  : 25-04-2023 : BT-101870 -  Breeze - Breeze Login Through QR Code - Start */
import { memo, useEffect, useMemo, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { QRExpire, resetAllAuthData, userGenerateQR } from '../../redux/actions/auth';
import { handleModal } from '../../redux/actions/modals';
import { getAppInfoData, clearLoginQRInterval, handleKeyDownOnDiv } from '../../utils/global_functions';
import { APP_INFO_DEFAULT_VALUES, APP_INFO_PARAMS } from '../../utils/global_variables';
import useAnalyticsEventTracker from '../../hooks/useAnalyticsEventTracker';

const LoginQR = (props) => {
    const brokerInformation = useSelector(state => state?.appInfo?.brokerInformation);
    /*Mahesh S  : 28-04-2023 : BT-101870 -  Breeze - Breeze Login Through QR Code - Start */
    const dispatch = useDispatch();

    const appInfo = useSelector(state => state?.appInfo?.appInfo);
    const objQRRes = useSelector(state => state?.auth?.objQRRes);//getting response for generate QR code api for QR image and errors
    const qrFailure = useSelector(state => state?.auth?.qrExpire);
    const [qrFail, setQRFail] = useState(false);
    const getEvent = useAnalyticsEventTracker('LOGIN');
    const [qr, setQr] = useState(null)

    useEffect(() => {
        if (!objQRRes?.data?.qrCode) {
            dispatch(userGenerateQR());
        } else {
            setQr(objQRRes?.data?.qrCode)
        }
    }, [objQRRes])



    const playstoreLink = useMemo(() => getAppInfoData(APP_INFO_PARAMS.APP_PLAY_STORE_LINK, APP_INFO_DEFAULT_VALUES.PLAY_STORE_LINK), [appInfo]);

    const appleId = useMemo(() => getAppInfoData(APP_INFO_PARAMS.APP_APP_STORE_LINK, APP_INFO_DEFAULT_VALUES.APPLE_ID), [appInfo]);

    useEffect(() => {
        if (qrFailure) {
            setQRFail(true);
            clearLoginQRInterval();
        }
    }, [qrFailure]);


    const handleQRLogin = () => {//onClick of QR code tab dispatching generate QR API and reseting allauthdata
        dispatch(userGenerateQR());
        getEvent("LOGIN_QRCode");
        dispatch(resetAllAuthData());
        dispatch(QRExpire(false));
        setQRFail(false);
    };



    const onHelpClick = () => {
        dispatch(handleModal([{ 'USAGE_GUIDE': true }]))
    }

    /*Mahesh S  : 28-04-2023 : BT-101870 -  Breeze - Breeze Login Through QR Code - end */
    return (
        <div className={props.className}>
            <div className='login-content p-1'>
                <Container fluid className='p-0'>
                    <Row className='g-0 my-2'>
                        <Col className='text-center'>
                            <div className='position-relative'>
                                {qrFail ? <div onClick={handleQRLogin} className='login-refresh-wrapper cursur-pointer focus p-1'>
                                    <div className='icon-refresh icon-20 icon-light mb-2'></div>
                                    <div className='font-medium font-size1 color-active-text'>Click to Refresh QR Code</div>
                                </div> : null}
                                <img className={qrFail ? 'img-fluid rounded-1 login-refresh-overlay' : 'img-fluid rounded-1'} alt='QR' src={qr} height="160" width="160" />
                            </div>
                        </Col>
                    </Row>
                    <Row className='g-0 my-3'>
                        <Col md={12} className='d-flex justify-content-center align-items-start gap-2'>
                            <div className='icon-20 icon-help-fill icon-grey float-start'></div>
                            <div className='font-regular font-size3 color-subtext float-start'>Have Questions? Click on</div>
                            <div><a data-testid='qr-login-help-link' className='font-medium font-size3 float-start focus' onClick={onHelpClick} href='#' onKeyDown={handleKeyDownOnDiv} >Help</a></div>
                        </Col>
                    </Row>

                    <div className='d-inline-flex flex-column gap-2'>
                        <Row className='g-0'>
                            <Col md={12} className='d-flex justify-content-start align-items-start gap-2'>
                                <div className='number-count float-start'>1</div>
                                <div className='font-regular font-size2 color-text text-wrap login-process-step'>Login to your account via our mobile application. You can get the application on <a data-testid="breeze-playstore-download-link" href={playstoreLink} target='_blank' className='font-medium focus'>Playstore</a> or <a data-testid="breeze-appstore-download-link" href={appleId} target='_blank' className='font-medium focus'>App store</a></div>
                            </Col>
                        </Row>
                        <Row className='g-0'>
                            <Col md={12} className='d-flex justify-content-start align-items-start gap-2'>
                                <div className='number-count float-start'>2</div>
                                <div data-testid='qr-login-process-step-two' className='font-regular font-size2 color-text text-wrap login-process-step'>Go to Settings from the Menu</div>
                            </Col>
                        </Row>
                        <Row className='g-0'>
                            <Col md={12} className='d-flex justify-content-start align-items-start gap-2'>
                                <div className='number-count float-start'>3</div>
                                <div className='font-regular font-size2 color-text text-wrap login-process-step'>Select QR login option</div>
                            </Col>
                        </Row>
                        <Row className='g-0'>
                            <Col md={12} className='d-flex justify-content-start align-items-start gap-2'>
                                <div className='number-count float-start'>4</div>
                                <div className='font-regular font-size2 color-text text-wrap login-process-step'>Point your phone to the above QR code to login to your account</div>
                            </Col>
                        </Row>
                        {/* QR Code Token for testing purpose starts here */}
                        {/* <Row>                            
                            <Col className='d-flex justify-content-start align-items-start'>
                                <div className='font-regular font-size2 color-text text-warp'>QR Token:</div>
                            </Col>
                        </Row> */}
                        {/* QR Code Token for testing purpose ends/ here */}
                    </div>
                </Container>
            </div>
            {/* <Row className='g-0 mt-3 ps-1'>
                <Col>
                    <div className='font-medium font-size1 color-subtext'>
                        {brokerInformation?.length ?
                            Object.entries(brokerInformation[0]).map(([key, item], i) => (
                                <span key={i}>
                                    {item.Exchange} - <span className="font-regular">Member ID: {item.MemberID}, SEBI REG NO.: {item?.ID}</span> |
                                </span>
                            ))
                            :null
                        }
                    </div>
                </Col>
            </Row> */}
        </div>
    );
};
export default memo(LoginQR);

/*Mahesh S  : 25-04-2023 : BT-101870 -  Breeze - Breeze Login Through QR Code - End */